import { useMemo } from "react";
import PropTypes from "prop-types";

import IconChevron from "../Icon/IconChevron";
import ContentQueryWidget from "../../pages/FlexibleLandingPage/components/ContentQueryWidget/component";

import { OLYMPICS_FILTER_NS as NAMESPACE } from "../../actions/DMP/constants";
import { useLocalPreferences } from "../../hooks/useLocalPreferences";
import { getSport } from "../OlympicSportsList/library";
import { useSportsContent } from "./library";
import {
    LOAD_MORE_URL,
    DEFAULT_PAGE_SIZE,
    DEFAULT_LAYOUT,
    A11Y_OLYMPICS_CONTENT_TEXT,
    NO_ARTICLES_FOUND,
} from "./constants";
import If from "../If/component";
import LinkWrap from "../LinkWrap/component";

const MyOlympicsContent = ({
    layout = DEFAULT_LAYOUT,
    pageSize = DEFAULT_PAGE_SIZE,
    displayMoreResultsButton = true,
}) => {
    const CQWLayout = layout || DEFAULT_LAYOUT;

    const { preferences } = useLocalPreferences(NAMESPACE);
    const sports = useMemo(() => {
        if (!preferences) {
            return [];
        }
        return Object.entries(preferences).reduce((accum, [key, value]) => {
            if (value) {
                const sport = getSport(key);
                sport && accum.push(sport);
            }
            return accum;
        }, []);
    }, [preferences]);

    const { isLoading, items } = useSportsContent(sports, pageSize);

    const contentLength = items.length ?? 0;

    const contentItems = contentLength
        ? items.map((item) => {
              return { ...item, showTimestamp: true };
          })
        : [];

    const widgetParams = {
        params: {
            pageWidget: {
                payload: {
                    items: contentItems,
                },
                metadata: {
                    layout: {
                        name: CQWLayout,
                        columns: 4,
                    },
                    heading: {
                        title: "",
                    },
                },
            },
        },
    };

    return (
        <div className="myOlympicsContent">
            {isLoading ? (
                <div className="loading">
                    <span className="loadingText">Loading...</span>
                    <div className="loader" />
                </div>
            ) : (
                <div>
                    {contentLength === 0 ? (
                        <p className="noArticlesMessage">{NO_ARTICLES_FOUND}</p>
                    ) : (
                        <span className="a11y" aria-live="polite">
                            {A11Y_OLYMPICS_CONTENT_TEXT}
                        </span>
                    )}
                    <ContentQueryWidget {...widgetParams} />

                    <If
                        value={
                            displayMoreResultsButton &&
                            !isLoading &&
                            contentLength > 0
                        }
                    >
                        <LinkWrap className="moreResults" url={LOAD_MORE_URL}>
                            More Results
                            <IconChevron />
                        </LinkWrap>
                    </If>
                </div>
            )}
        </div>
    );
};

MyOlympicsContent.propTypes = {
    layout: PropTypes.string,
    pageSize: PropTypes.number,
    displayMoreResultsButton: PropTypes.bool,
};

export default MyOlympicsContent;
